import {AirtablePromotionItem} from '../../models/airtable';
import {AppRoute} from '../../models/AppRoute';
import {isGiftCardsPromotion} from '../../utils/giftCards';

/**
 * Moved from `promotionsStore.navigateToGiftCardsPromotionOrLoadingScreen`
 * (DIS-1567). `rawPromotions` is a parameter rather than a store read so the
 * function stays pure and testable; callers pass `usePromotions().rawPromotions`.
 *
 * When no gift-cards promotion has loaded yet, this routes to
 * `GIFT_CARDS_PROMOTION_WAITER`, which waits on the same collection and then
 * either forwards to the promotion or offers the BUY A GIFT CARD fallback.
 */
export const navigateToGiftCardsPromotionOrLoadingScreen = (
  rawPromotions: AirtablePromotionItem[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigate: (...args: any[]) => void,
  fromRoot = false,
) => {
  const giftCardsPromotion = rawPromotions?.find(isGiftCardsPromotion);
  if (giftCardsPromotion) {
    if (fromRoot) {
      navigate(AppRoute.ROOT, {
        screen: AppRoute.MAIN,
        params: {
          screen: AppRoute.PROMOTION,
          params: {
            promotion: giftCardsPromotion,
          },
        },
      });
    } else {
      navigate(AppRoute.PROMOTION, {
        promotion: giftCardsPromotion,
      });
    }
  } else {
    if (fromRoot) {
      navigate(AppRoute.ROOT, {
        screen: AppRoute.MAIN,
        params: {
          screen: AppRoute.GIFT_CARDS_PROMOTION_WAITER,
        },
      });
    } else {
      navigate(AppRoute.GIFT_CARDS_PROMOTION_WAITER);
    }
  }
};
